document.addEventListener('DOMContentLoaded', function () {
    function getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    // Function to set a cookie with a specific name, value, and expiration time (in hours)
    function setCookie(name, value, hours) {
        const d = new Date();
        d.setTime(d.getTime() + (hours * 60 * 60 * 1000));
        const expires = "expires=" + d.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    // Function to get the value of a cookie by name
    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i].trim();
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // Function to delete a cookie by name
    function deleteCookie(name) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }

    function updatePhoneNumber(phoneNumber) {
        if (!phoneNumber) return;

        const mobileNosElements = document.querySelectorAll('.dni-number');
        mobileNosElements.forEach(element => {
            const elementMobileNumber = element.querySelector('span');
            if (elementMobileNumber) {
              elementMobileNumber.innerHTML = phoneNumber;
            }
            // element.innerHTML = phoneNumber;
            element.href = "tel:" + phoneNumber;
        });

        const mobileNosTelElements = document.querySelectorAll('a[href^="tel:"]');
        mobileNosTelElements.forEach(element => {
            element.href = "tel:" + phoneNumber;
        });
      
    }

    // Maps to associate `utm_adgroupid` or `utm_id` values with specific phone numbers
    const phoneNumberMapping = {
      '21900613838': '+91-22-42035306',
      '16096874760': '+91-22-42035324',
      '20513404464': '+91-22-42035326',
      '16014895349': '+91-22-42035327',
      '15862578651': '+91-22-42035328',
      '16385824488': '+91-22-47734602',
      '16095035938': '+91-22-47734604',
      '208480957': '+91-22-47734606',
      '15749976477': '+91-22-47734611',
      '15851771427': '+91-22-47734612',
      '196568437': '+91-22-47734613',
      '943298527': '+91-22-47734614',
      '196836997': '+91-22-47734615',
      '944854247': '+91-22-47734616',
      '379116397': '+91-22-47734617',
      '21441555299': '+91-22-47734630',
      '21463478280': '+91-22-47734631',
      '22905693034': '+91-22-42035303',
      '20255847276': '+91-22-42035307',
      '16389001575': '+91-22-42035308',
      '22950560123': '+91-22-42035309',
      '23347687143': '+91-22-47734600',
      '23310399757': '+91-22-47734601',
      '22935578541': '+91-22-47734603',
      '22917855249': '+91-22-47734605',
      '22936915366': '+91-22-47734607',
      '22068214034': '+91-22-47734608',
      '23093588157': '+91-22-47734609',
      '21181217035': '+91-22-47734610',
      '23199466711': '+91-22-47734618',
      '23027537882': '+91-22-47734619',
      '23279587628': '+91-22-47734620',
      '22987689299': '+91-22-47734621',
      '22962751849': '+91-22-47734622',
      '17823956824': '+91-22-47734623',
      '21820570009': '+91-22-47734624',
      '20281375101': '+91-22-47734625',
      '21049914696': '+91-22-47734626',
      '15931196281': '+91-22-47734627',
      '23096201256': '+91-22-47734628',
      '23260074384': '+91-22-47734629',
      '22937449916': '+91-22-47734632',
      '22908157369': '+91-22-42035325',
      '22839341957': '+91-22-47734633',
      '23027546060': '+91-22-47734634',
      '22945760301': '+91-22-47734635',
       '20063628168': '+91-22-47734642',
    '20068057196': '+91-22-47734643',
    '23064676703': '+91-22-47734644',
    '23392270457': '+91-22-47734645',
    '23479765088': '+91-22-47734646',
    '23479877452': '+91-22-47734647',
    '23481808704': '+91-22-47734648',
    '23484412714': '+91-22-47734649',
    '23550401204': '+91-22-47734650',
    '23611691198': '+91-22-47734651',
    '23633342314': '+91-22-47734652',
    '23645608530': '+91-22-47734653',
    '23655813358': '+91-22-47734654',
      '22059334711': '+91-22-47734636',
      '22962190075': '+91-22-47734637',
      '196035637': '+91-22-47734638',
      '22936221297': '+91-22-47734639',
      '20547932597': '+91-22-47734640',
      '19175067066': '+91-22-47734641'
      
    }

    function processQueryParams() {
        let phoneNumber;
        const utmAdgroupId = getQueryParam('utm_adgroupid');
        const utmId = getQueryParam('utm_id');

        if (utmAdgroupId) {
            setCookie('utm_adgroupid', utmAdgroupId, 1);
            deleteCookie('utm_id');
            phoneNumber = phoneNumberMapping[utmAdgroupId];
        } else if (utmId) {
            setCookie('utm_id', utmId, 1);
            deleteCookie('utm_adgroupid');
            phoneNumber = phoneNumberMapping[utmId];
        } else {
            // If no URL parameter, fallback to cookie values
            const storedAdgroupId = getCookie('utm_adgroupid');
            const storedUtmId = getCookie('utm_id');
            phoneNumber = phoneNumberMapping[storedAdgroupId] || phoneNumberMapping[storedUtmId];
        }

        updatePhoneNumber(phoneNumber);
    }

    // Process `utm_adgroupid` and `utm_id` parameters
    processQueryParams();
});
